import { createStore } from 'vuex'
import about from '@/apis/about'
export default createStore({
  state: {
    home:{
      avatar:"",
      nickname:"",
      userId:"",
      balance:""
    }
  },
  getters: {},
  mutations: {

  },
  actions: {
    homeconter({state}){
      about.home().then(res=>{
        state.home = res.data.data;
      })
    }
  },
  modules: {
  }
})
